<style scoped lang="scss" type="text/scss">

</style>

<template>
    <el-dialog
            :title="'正在' + (isUpdate ? '更新' : '添加') + '住宿信息'"
            :close-on-click-modal="false"
            @closed="reset"
            :visible.sync="visibleSync"
            width="70%">
        <el-form :model="accommodationInfo" ref="form" :rules="rules" label-width="80px">
            <el-form-item label="旅店名称" prop="hotel_name">
                <el-input v-model="accommodationInfo.hotel_name" placeholder="如：某某快捷旅店"></el-input>
            </el-form-item>
            <el-form-item label="入住人数" prop="people_number">
                <el-input class="full-width" placeholder=""
                          v-model="accommodationInfo.people_number"></el-input>
            </el-form-item>

            <el-form-item style="margin-bottom: 0;">
                <el-button type="primary" plain @click="confirm()" :loading="requesting">保存</el-button>
                <el-button @click="cancel()">取消</el-button>
                <el-button v-if="deletable" type="danger" style="float: right;" @click="remove()"
                           :loading="deleteRequesting">删除
                </el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
    export default {
        name: '',
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            isUpdate: {
                type: Boolean,
                default: false
            },
            deletable: {
                type: Boolean,
                default: false
            },
            id: {
                type: Number,
                default: null
            }
        },
        watch: {
            visible (visible) {
                this.visibleSync = visible;
                if (!visible) return;
                const id = this.id;
                if (id === null || id === undefined) {
                    this.accommodationInfo = {};
                } else {
                    this.$store.dispatch('player/loadAccommodationInfo', {
                        id
                    }).then(response => {
                        this.accommodationInfo = response.data;
                    });
                }
            },
            visibleSync (visibleSync) {
                this.$emit('update:visible', visibleSync);
            }
        },
        data () {
            const checkNumber = async (rule, value, callback) => {
                if (isNaN(+value)) {
                    callback(new Error('入住人数只能是数字'));
                }
                if (parseInt(value) !== +value) {
                    callback(new Error('入住人数只能是整数'));
                }
                if (+value < 0) {
                    callback(new Error('入住人数不能小于 0'));
                }
                if (+value > 10000) {
                    callback(new Error('入住人数不能超过 10,000'));
                }
            };
            return {
                visibleSync: null,
                accommodationInfo: {},
                requesting: false,
                deleteRequesting: false,
                rules: {
                    hotel_name: [
                        {required: true, message: '旅店名称不能为空', trigger: 'blur'},
                        {min: 1, max: 30, message: '旅店名称不能超过 30 个字', trigger: 'blur'}
                    ],
                    people_number: [
                        {required: true, message: '入住人数不能为空', trigger: 'blur'},
                        {validator: checkNumber, trigger: 'blur'}
                    ]
                }
            };
        },
        computed: {
            currentManagedPlayerId () {
                return this.$store.state.player.currentManagedPlayerId;
            }
        },
        methods: {
            remove () {
                this.$deleteConfirm().then(_ => {
                    this.$normalRequest('player/deleteAccommodation', {
                        id: this.id
                    }, '删除成功', true, this, 'deleteRequesting').then(_ => {
                        this.$emit('need-reload');
                        this.reset();
                    }).catch(_ => {
                    });
                }).catch(_ => {
                });
            },
            confirm () {
                if (this.isUpdate) {
                    this.update();
                } else {
                    this.create();
                }
            },
            create () {
                this.handleTemplate('player/createAccommodation', '创建成功');
            },
            update () {
                this.handleTemplate('player/updateAccommodation', '更新成功');
            },
            handleTemplate (actionName, tip) {
                this.$refs.form.validate((valid) => {
                    if (!valid) return false;
                    const accommodationInfo = this.accommodationInfo;
                    accommodationInfo.people_number = +accommodationInfo.people_number;
                    this.$normalRequest(actionName, {
                        id: this.currentManagedPlayerId,
                        ...accommodationInfo
                    }, tip, true, this, 'requesting').then(_ => {
                        this.afterSuccess();
                    }).catch(_ => {
                    });
                });
            },
            cancel () {
                this.reset();
            },
            afterSuccess () {
                this.$emit('need-reload');
                this.reset();
            },
            reset () {
                this.$refs.form.clearValidate();
                this.$refs.form.resetFields();
                this.visibleSync = false;
                this.accommodationInfo = {};
            }
        }
    };
</script>
